import http from '../services/http';

import {
    ALL_PRESENTERS_ENDPOINT,
    CREATE_PRESENTER_ENDPOINT,
    UPDATE_PRESENTER_ENDPOINT,
    DELETE_PRESENTER_ENDPOINT,
    UPLOAD_PRESENTER_PICTURE,
    DELETE_PRESENTER_PICTURE_ENDPOINT,
    ADD_PRESENTER_TO_ELEARNING_ENDPOINT,
    GET_PRESENTER_SEARCH_RESULTS,
    generateEndpoint,
} from './endpoints';

export default (() => {

    const getAll = () => {

        return http.get(ALL_PRESENTERS_ENDPOINT);
    };
    
    const create = (params) => {

        return http.post(CREATE_PRESENTER_ENDPOINT, params);
    };

    const update = (params) => {

        var endpoint = generateEndpoint(UPDATE_PRESENTER_ENDPOINT, { id: params.id });

        return http.put(endpoint, params);
    };

    const remove = (id) => {

        var endpoint = generateEndpoint(DELETE_PRESENTER_ENDPOINT, { id });

        return http.delete(endpoint);
    };

    const uploadProfilePicture = (id, file) => {

        var endpoint = generateEndpoint(UPLOAD_PRESENTER_PICTURE, { id });

        const payload = generateImageUploadPayload(file);

        return http.post(endpoint, payload);
    };

    const generateImageUploadPayload = (file) => {

        var formData = new FormData();

        formData.append('profile_picture', file);

        return formData;
    };
    
    const deletePicture = (presenterId) => {

        var endpoint = generateEndpoint(DELETE_PRESENTER_PICTURE_ENDPOINT, { id: presenterId });

        return http.delete(endpoint);
    };

    const searchPresenters = searchTerm => {
        return http.get(GET_PRESENTER_SEARCH_RESULTS, {params: searchTerm});
    }

    return {
        create,
        update,
        remove,
        getAll,
        uploadProfilePicture,
        deletePicture,
        searchPresenters
    };

})();


// WEBPACK FOOTER //
// ./services/presenters.js